export const topregiony = {
  regiony: {
    "@ile": "22",
    item: [
      {
        cena: "439",
        lokalizacje: "CIL000095",
        nazwa: "Gran Canaria",
        url: "www.wyspykanaryjskie.pl/wakacje/gran-canaria.xml"
      },
      {
        cena: "653",
        lokalizacje: "CIL000280",
        nazwa: "San Augustin",
        url: "www.wyspykanaryjskie.pl/wakacje/gran-canaria-san-augustin.xml"
      },
      {
        cena: "509",
        lokalizacje: "CIL000234",
        nazwa: "Playa del Ingles",
        url: "www.wyspykanaryjskie.pl/wakacje/gran-canaria-playa-del-ingles.xml"
      },
      {
        cena: "439",
        lokalizacje: "CIL000170",
        nazwa: "Maspalomas",
        url: "www.wyspykanaryjskie.pl/wakacje/gran-canaria-maspalomas.xml"
      },
      {
        cena: "539",
        lokalizacje: "CIL000262",
        nazwa: "Puerto Rico",
        url: "www.wyspykanaryjskie.pl/wakacje/gran-canaria-puerto-rico.xml"
      },
      {
        cena: "467",
        lokalizacje: "CIL000332",
        nazwa: "Teneryfa",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa.xml"
      },
      {
        cena: "900",
        lokalizacje: "CIL000159",
        nazwa: "Los Cristianos",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa-los-cristianos.xml"
      },
      {
        cena: "936",
        lokalizacje: "CIL000216",
        nazwa: "Playa de las Americas",
        url:
          "www.wyspykanaryjskie.pl/wakacje/teneryfa-playa-de-las-americas.xml"
      },
      {
        cena: "732",
        lokalizacje: "CIL000053",
        nazwa: "Costa Adeje",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa-costa-adeje.xml"
      },
      {
        cena: "1618",
        lokalizacje: "CIL000239",
        nazwa: "Playa Paraiso",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa-playa-paraiso.xml"
      },
      {
        cena: "787",
        lokalizacje: "CIL000259",
        nazwa: "Puerto de Santiago",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa-puerto-de-santiago.xml"
      },
      {
        cena: "1021",
        lokalizacje: "CIL000160",
        nazwa: "Los Gigantes",
        url: "www.wyspykanaryjskie.pl/wakacje/teneryfa-los-gigantes.xml"
      },
      {
        cena: "467",
        lokalizacje: "CIL000255",
        nazwa: "Region Puerto de la Cruz",
        url:
          "www.wyspykanaryjskie.pl/wakacje/teneryfa-puerto-de-la-cruz-teide.xml"
      },
      {
        cena: "458",
        lokalizacje: "CIL000088",
        nazwa: "Fuerteventura",
        url: "www.wyspykanaryjskie.pl/wakacje/fuerteventura.xml"
      },
      {
        cena: "487",
        lokalizacje: "CIL000052",
        nazwa: "Corralejo",
        url: "www.wyspykanaryjskie.pl/wakacje/fuerteventura-corralejo.xml"
      },
      {
        cena: "528",
        lokalizacje: "CIL000367",
        nazwa: "Wyspa Lanzarote",
        url: "www.wyspykanaryjskie.pl/wakacje/wyspa-lanzarote.xml"
      },
      {
        cena: "573",
        lokalizacje: "CIL000260",
        nazwa: "Puerto del Carmen",
        url: "www.wyspykanaryjskie.pl/wakacje/lanzarote-puerto-del-carmen.xml"
      },
      {
        cena: "528",
        lokalizacje: "CIL000056",
        nazwa: "Costa Teguise",
        url: "www.wyspykanaryjskie.pl/wakacje/lanzarote-costa-teguise.xml"
      },
      {
        cena: "847",
        lokalizacje: "CIL000093",
        nazwa: "La Gomera, La Palma i El Hierro",
        url: "www.wyspykanaryjskie.pl/wakacje/gomera-palma-hierro.xml"
      },
      {
        cena: "1319",
        lokalizacje: "CIL000134",
        nazwa: "Wyspa La Palma",
        url: "www.wyspykanaryjskie.pl/wakacje/wyspa-la-palma.xml"
      },
      {
        cena: "847",
        lokalizacje: "CIL000127",
        nazwa: "Wyspa La Gomera",
        url: "www.wyspykanaryjskie.pl/wakacje/wyspa-la-gomera.xml"
      },
      {
        cena: "1963",
        lokalizacje: "CIL000297",
        nazwa: "San Sebastian de la Gomera",
        url: "www.wyspykanaryjskie.pl/wakacje/san-sebastian-de-la-gomera.xml"
      }
    ]
  }
};
